import axios from "axios";
import Cookies from "js-cookie";
import {ErrorToaast} from "../utils/toast/Toast";

export class BaseApi {
  // baseUrl = "http://localhost:5252/api";
     baseUrl = "/api";
    version = "v1"  ;
    cancelTokenSource = axios.CancelToken.source();
    handleCancelRequest = async () => {
        this.cancelTokenSource.cancel("Request was canceled");
    };

    axiosInstance(auth = false, cookie = "") {
         let headers = {
            "Content-type": "application/json",
        };
        if (auth) {
            headers.Authorization = `Bearer ${cookie}`;
        }

        var axioss = axios.create({
            baseURL: `${this.baseUrl}/${this.version}`,
            headers,
            cancelToken: this.cancelTokenSource.token,
        });
        axioss.interceptors.response.use((response) => response, (error) => {

            if (error?.response?.status == 401) {
                Cookies.remove('ut');
                Cookies.remove('cst');
                ErrorToaast("کاربری شما منقضی شده است")
                window.location.assign("/login");
            }
            throw error;
        });
        return axioss;
    }
}
